<app-button [src]="src" class="outset-with-icon outset-with-icon--big">
    <i class="fas fa-file-pdf"></i>
    <span i18n>PDF</span>
</app-button>
